import { loadable } from '@elliemae/pui-app-sdk';

export const MDM = loadable(
  () =>
    import(/* webpackChunkName: "MDM" */ /* webpackPrefetch: true */ './index'),
);
